import { connect } from 'react-redux';
import { useSelectedProvider } from '../../../components/App/ProviderContainer/useSelectedProvider';

import { AppState, ConnectedPropsWithoutDispatch } from '../../../stores/redux-store';
import { resetCredentials as resetCredentialsConnect } from '../../../stores/credentials-store';

import {
  LoadingOverlay as LoadingOverlayImport,
  LoadingOverlayProps,
} from '../../../core/screens/LoadingOverlay/LoadingOverlay';
import { applicationParameters } from '../../../utilities/application-parameters';
import {
  BusinessAccountCheckMachineView as BusinessAccountCheckMachineViewImport,
  BusinessAccountCheckMachineViewProps,
} from './BusinessAccountCheckMachineView';

export type BusinessAccountCheckDirectorProps = PropsFromRedux & {
  BusinessAccountCheckMachineView?: React.ComponentType<BusinessAccountCheckMachineViewProps>;
  LoadingOverlay?: React.ComponentType<LoadingOverlayProps>;
};

export const BusinessAccountCheckDirectorPresenter = ({
  reportDescription,
  resetCredentials,
  BusinessAccountCheckMachineView = BusinessAccountCheckMachineViewImport,
  LoadingOverlay = LoadingOverlayImport,
  session,
}: BusinessAccountCheckDirectorProps) => {
  const customerReferenceId = applicationParameters.get('customerReferenceId');
  const externalReference =
    session?.externalReference || applicationParameters.get('externalReference');
  const { selectedProvider } = useSelectedProvider();

  if (!reportDescription) {
    return <LoadingOverlay />;
  }

  return (
    <BusinessAccountCheckMachineView
      customerReferenceId={customerReferenceId}
      externalReference={externalReference}
      selectedProvider={selectedProvider}
      onCancel={resetCredentials}
      reportDescription={reportDescription}
    />
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    reportDescription: state.reports.reportDescription,
    session: state.session.data,
  };
};

const mapDispatchToProps = {
  resetCredentials: resetCredentialsConnect,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const BusinessAccountCheckDirector = connector(BusinessAccountCheckDirectorPresenter);
